import { scoreBarFill } from '../../utils/scoreColors';

const scoreColor = (score) => scoreBarFill(score);

export function LabelFermata({ label, score }) {
  const col = scoreColor(score);
  return (
    <div style={{ display: "flex", alignItems: "center", gap: 7, lineHeight: 1 }}>
      <span style={{ color: col, fontSize: 10, lineHeight: 1 }}>⬤</span>
      <span style={{ fontFamily: "Work Sans, sans-serif", fontWeight: 800, fontSize: 13, color: "#fff" }}>
        {label}
      </span>
      <span style={{
        background: col, color: "#1B1C1C", borderRadius: 20,
        padding: "1px 8px", fontSize: 12, fontWeight: 900, marginLeft: 2,
      }}>
        {score.toFixed(1)}
      </span>
    </div>
  );
}

export function LabelPuntoVendita({ label, score }) {
  const col = scoreColor(score);
  return (
    <div style={{ display: "flex", alignItems: "center", gap: 7, lineHeight: 1 }}>
      <span style={{ color: col, fontSize: 10 }}>■</span>
      <span style={{ fontFamily: "Work Sans, sans-serif", fontWeight: 800, fontSize: 13, color: "#fff" }}>
        {label}
      </span>
      <span style={{
        background: col, color: "#1B1C1C", borderRadius: 20,
        padding: "1px 8px", fontSize: 12, fontWeight: 900, marginLeft: 2,
      }}>
        {score.toFixed(1)}
      </span>
    </div>
  );
}

export function LabelLinea({ routeNum, score, routeColor }) {
  const col = routeColor ?? scoreColor(score);
  return (
    <div style={{ display: "flex", alignItems: "center", gap: 7, lineHeight: 1 }}>
      <span style={{
        background: col, color: "#fff", borderRadius: 6,
        padding: "1px 7px", fontSize: 12, fontWeight: 900, fontFamily: "monospace",
        boxShadow: `0 0 8px ${col}66`,
      }}>
        {routeNum}
      </span>
      <span style={{ fontFamily: "Work Sans, sans-serif", fontWeight: 700, fontSize: 12, color: "rgba(255,255,255,0.85)" }}>
        Linea
      </span>
      <span style={{
        background: scoreColor(score), color: "#1B1C1C", borderRadius: 20,
        padding: "1px 8px", fontSize: 11, fontWeight: 900,
      }}>
        {score.toFixed(1)}
      </span>
    </div>
  );
}
